var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1000 200",
    width: 1000,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1000,
    height: 200,
    fill: "#0b1928"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 145L41.7 134.5C83.3 124 166.7 103 250 95.5C333.3 88 416.7 94 500 100.7C583.3 107.3 666.7 114.7 750 117.5C833.3 120.3 916.7 118.7 958.3 117.8L1000 117L1000 0L958.3 0C916.7 0 833.3 0 750 0C666.7 0 583.3 0 500 0C416.7 0 333.3 0 250 0C166.7 0 83.3 0 41.7 0L0 0Z",
    fill: "#a9c5e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 94L41.7 95.3C83.3 96.7 166.7 99.3 250 91.3C333.3 83.3 416.7 64.7 500 61.7C583.3 58.7 666.7 71.3 750 85C833.3 98.7 916.7 113.3 958.3 120.7L1000 128L1000 0L958.3 0C916.7 0 833.3 0 750 0C666.7 0 583.3 0 500 0C416.7 0 333.3 0 250 0C166.7 0 83.3 0 41.7 0L0 0Z",
    fill: "#6a8dba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 80L41.7 71C83.3 62 166.7 44 250 32.7C333.3 21.3 416.7 16.7 500 15.3C583.3 14 666.7 16 750 16.8C833.3 17.7 916.7 17.3 958.3 17.2L1000 17L1000 0L958.3 0C916.7 0 833.3 0 750 0C666.7 0 583.3 0 500 0C416.7 0 333.3 0 250 0C166.7 0 83.3 0 41.7 0L0 0Z",
    fill: "#29598f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutWaves);
export default __webpack_public_path__ + "static/media/about_waves.852fe444e78863c8b89ac1ac2a0ab0ee.svg";
export { ForwardRef as ReactComponent };